module.exports = __webpack_public_path__ + "static/media/rollet_goriz.0b74cbd9.png";